import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import reducer from './reducer'

const rootReducer = (history) => combineReducers({
  ...reducer,
  router: connectRouter(history)
})

export default rootReducer